<template>
    <FormInputContainer class="FormTonsInput" :inputId="`I${_uid}`" :label="label" :errors="errors" :required="required">
        <input
            :id="`I${_uid}`"
            v-bind="$attrs"
            type="number"
            step="0.01"
            placeholder="0.00"
            :value="formattedValue"
            v-on="{ [lazy ? 'change' : 'input']: handleInput }"
        />
    </FormInputContainer>
</template>


<script>
import { formatTons } from '@/utils/formatting';
import FormInputContainer from './FormInputContainer';

export default {
    name: 'FormTonsInput',
    inheritAttrs: false,

    components: { FormInputContainer },

    props: {
        value: { type: Number },
        label: { type: String },
        lazy: { type: Boolean, default: false },
        errors: { type: Array },
        required: { type: Boolean, default: false },
    },

    computed: {
        formattedValue() {
            return this.value != null ? formatTons(this.value) : null;
        },
    },

    methods: {
        handleInput(event) {
            if (event.target.validity.badInput) {
                event.target.value = this.value;
                return;
            }

            const result = Number.parseFloat(event.target.value);

            this.$emit('input', Number.isFinite(result) ? Math.round(result * 2000) : null);
        },
    },
}
</script>


<style lang="scss" scoped>
@import 'globals.scss';
.FormTonsInput {
    input {
        @extend %form-control;
        padding-right: 10px;
    }
}
</style>
